import React from 'react';
import { Col, Container, Dropdown, Image, Navbar, Row } from 'react-bootstrap';
import { logout } from '../../services/util/auth';
import styles from './mySettings.module.scss';
import { useHistory } from 'react-router-dom';
import UserInfo from './userInfo';
import CalendarSettings from './calendarSettings';
import CustomNavbar from '../adminPanel/customNavbar';
import CustomerSupport from './customerSupport';
import {
    Route,
    Switch,
    Redirect,
    NavLink
} from 'react-router-dom';

function MySettings(props) {
    const history = useHistory();

    const dropdownSelect = (e) => {
        if (e === '1') {
            props.history.push("/my-settings")
        }
        if (e === '2') {
            props.history.push("/my-settings/customer-support")
        }
        if (e === '3') {
            logout()
            props.history.push("/signin")
        }
    }

    const goToSupportPage = () => {
        props.history.push("/my-settings/customer-support")
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="23" stroke="#2DA6C0" strokeOpacity="0.75" strokeWidth="1.5" />
                        <circle cx="24" cy="24" r="23" stroke="#2DA6C0" strokeOpacity="0.75" strokeWidth="1.5" />
                        <path d="M23.9999 22.584C27.5378 22.584 30.4166 19.7052 30.4166 16.1673V15.0007C30.4166 11.4627 27.5378 8.58398 23.9999 8.58398C20.462 8.58398 17.5833 11.4627 17.5833 15.0007V16.1673C17.5833 19.7052 20.462 22.584 23.9999 22.584Z" fill="#2DA6C0" fillOpacity="0.75" />
                        <path d="M32.9122 26.1926C30.9568 25.611 27.8232 24.918 24 24.918C20.1768 24.918 17.0432 25.611 15.0878 26.1926C13.0917 26.7864 11.75 28.5848 11.75 30.6673V34.8346C11.75 35.1566 12.0113 35.418 12.3333 35.418H35.6667C35.9887 35.418 36.25 35.1566 36.25 34.8346V30.6673C36.25 28.5848 34.9083 26.7864 32.9122 26.1926Z" fill="#2DA6C0" fillOpacity="0.75" />
                    </svg>
                </div>
                <div className={styles.arrowIconSvgDiv}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 7.5L10 12.5L15 7.5" stroke="#2DA6C0" strokeOpacity="0.75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    return (
        <div className={styles.mainContainer}>
            <div className={styles.topNavComponent}>
                <Navbar expand="lg" className={styles.navbar}>
                    <div className="mr-auto">
                        <div className={styles.companyLogoContainer}>
                            <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/companylogo.png`} fluid />
                        </div>
                    </div>
                    <div className={styles.userDetails}>
                        <p onClick={() => goToSupportPage()} activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}><span className={styles.subCategoryIcons}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3">
                                </path><line x1="12" y1="17" x2="12.01" y2="17"></line>
                            </svg>
                        </span>
                        </p>
                        <p className={styles.currentUserName}>{localStorage.getItem("name")}</p>
                        <Dropdown
                            alignRight={true}
                            onSelect={(e) => dropdownSelect(e)}
                        >
                            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            </Dropdown.Toggle>

                            <Dropdown.Menu className={styles.dropdownMenu}>
                                <div className={styles.userDetailsBox}>
                                    <div className={styles.userAvatarContainer}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/navigation_dropdown_avatar.png`} fluid className={styles.userAvatar} />
                                    </div>
                                    <div className={styles.userDetailsContainer}>
                                        <p className={styles.userDetailsTopic}>{localStorage.getItem("name")}</p>
                                    </div>
                                </div>
                                <Dropdown.Item eventKey="1" className={styles.dropdownText}><i className={`${styles.changePasswordIcon} ${"fas fa-cog"}`}></i>My Settings</Dropdown.Item>
                                <Dropdown.Item eventKey="2" className={styles.dropdownText}><i className={`${styles.signoutIcon} ${"fas fa-question-circle"}`}></i>Help</Dropdown.Item>
                                <Dropdown.Item eventKey="3" className={styles.dropdownTextLogout}><i className={`${styles.signoutIcon} ${"fas fa-sign-out-alt"}`}></i>Logout</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Navbar>
            </div>
            <div className={styles.bodyContainer}>
                <Row className="ml-0 mr-0">
                    <Col sm={5} lg={4} xl={3} className={styles.topicSideColumn}>
                        <Container>
                            <p className={styles.pageTopic}>My Settings</p>
                            <div>
                                <NavLink to="/company" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                                    <span className={styles.subCategoryIcons}>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 8L8 12L12 16" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M16 12H8" stroke="#828282" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>Back to Dashboard</span>
                                </NavLink>
                            </div>
                            <div>
                                <NavLink to="/my-settings/user-info" className={styles.subCategoryContainer} activeClassName={styles.subCategoryContainerActive}>
                                    <span className={styles.subCategoryIcons}>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M23.3334 24.5V22.1667C23.3334 20.929 22.8417 19.742 21.9666 18.8668C21.0914 17.9917 19.9044 17.5 18.6667 17.5H9.33341C8.09574 17.5 6.90875 17.9917 6.03358 18.8668C5.15841 19.742 4.66675 20.929 4.66675 22.1667V24.5" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M13.9999 12.8333C16.5772 12.8333 18.6666 10.744 18.6666 8.16667C18.6666 5.58934 16.5772 3.5 13.9999 3.5C11.4226 3.5 9.33325 5.58934 9.33325 8.16667C9.33325 10.744 11.4226 12.8333 13.9999 12.8333Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>User Info</span>
                                </NavLink>
                            </div>
                            <div>
                                <NavLink to="/my-settings/calendar" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                                    <span className={styles.subCategoryIcons}>
                                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22.1667 4.66699H5.83333C4.54467 4.66699 3.5 5.71166 3.5 7.00033V23.3337C3.5 24.6223 4.54467 25.667 5.83333 25.667H22.1667C23.4553 25.667 24.5 24.6223 24.5 23.3337V7.00033C24.5 5.71166 23.4553 4.66699 22.1667 4.66699Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M18.6665 2.33301V6.99967" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M9.3335 2.33301V6.99967" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M3.5 11.667H24.5" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>Calendar Settings</span>
                                </NavLink>
                            </div>
                            <div>
                                <NavLink to="/my-settings/customer-support" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                                    <span className={styles.subCategoryIcons}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3">
                                            </path><line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                    </span>
                                    <span className={styles.subCategory}>Customer Support</span>
                                </NavLink>
                            </div>
                        </Container>

                    </Col>
                    <Col sm={7} lg={8} xl={9}>
                        <Container className="p-5">
                            <Switch>
                                <Route path='/my-settings/user-info' exac={true} render={props => <UserInfo {...props} />} />
                                <Route path='/my-settings/calendar' exac={true} render={props => <CalendarSettings {...props} />} />
                                <Route path='/my-settings/customer-support' exac={true} render={props => <CustomerSupport {...props} />} />
                                <Redirect from="/" to="/my-settings/user-info" />
                            </Switch>
                        </Container>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default MySettings;
